import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useAllowedUserStatusOptionsAndPositions.ts
var DEFAULT_CACHE_STRATEGY = "cache-only";
function useAllowedUserStatusOptionsAndPositions(targetUserId, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetAllowedUserStatusOptionsAndPositions.v1, targetUserId ? { targetUserId } : void 0, {
		cacheStrategy: opts.cacheStrategy || DEFAULT_CACHE_STRATEGY,
		fire: !!targetUserId && fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useAllowedUserStatusOptionsAndPositions };

//# sourceMappingURL=useAllowedUserStatusOptionsAndPositions.js.map